/* @flow weak */
import Button from 'components/Button.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';
import FeatureStore from 'stores/FeatureStore';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import UserActions from 'user/UserActions';
import UserEmailsForm from './UserEmailsForm.jsx';
import UserPasswordForm from './UserPasswordForm.jsx';
import UserPersonalInfoForm from './UserPersonalInfoForm.jsx';
import UserSchoolsForm from './UserSchoolsForm.jsx';
import UserSignatureForm from './UserSignatureForm.jsx';
import Divider from 'components/Divider.jsx';

import './styles/UserSettingsView.scss';

const UserSettingsView = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  componentWillMount() {
    if (FeatureStore.hasFeature('web.new_account')) {
      this.context.router.replace('/settings/profile');
    }
  },

  deleteAccount() {
    window.location = LinkConstants.MARKETING;
  },

  renderAdditionalForms() {
    return {
      teacher: () => [
        <UserSignatureForm key="UserSignatureForm" />,
        <Divider key="Divider-UserSignatureForm" />,
      ],
      student: () => [],
      parent: () => [],
    }[CurrentUser.getUser().getRole()]();
  },

  renderConfirmModal() {
    const subtext = CurrentUser.getUser().canCreateGroups() ?
    'You will no longer have access to your classes or participants. ' +
    'This action can’t be undone.' :
    'You will no longer have access to your classes. This action can’t be undone.';

    return (
      <ConfirmDialog
        eventScreenName="UserSettingsView"
        actionButtonText="Delete"
        cancelButtonText="Cancel"
        size="xsmall"
        glyph="trash"
        glyphColor="lava"
        onConfirm={this.deleteAccount}
        preConfirmPromise={UserActions.delete}
        title="Are you sure you want to delete your account?"
        subtext={subtext}
      />
    );
  },

  renderDeleteAccountForm() {
    return (
      <div>
        <ModalTrigger modal={this.renderConfirmModal()}>
          <Button
            className="UserSettingsView-deleteAccountBtn"
            size="xsmall"
            level="secondary"
            color="lava"
            eventElementName="UserSettingsView-deleteAccountBtn">
            Delete account
          </Button>
        </ModalTrigger>
      </div>
    );
  },

  renderSchoolsSection() {
    return (
      <div>
        <UserSchoolsForm />
        <Divider />
      </div>
    );
  },

  renderTermsAndPrivacyLink() {
    return (
      <div>
        <Link
          href={LinkConstants.TERMS_OF_SERVICE}
          target="_blank"
          color="thunder">
          Terms & Privacy
        </Link>
      </div>
    );
  },

  render() {
    return (
      <div className={cx('UserSettingsView', this.props.className)}>
        {this.renderAdditionalForms()}
        <UserPersonalInfoForm />
        <Divider />
        <UserEmailsForm />
        <Divider />
        {CurrentUser.getUser().isOrganizationPickerEligible() &&
         this.renderSchoolsSection()}
        <UserPasswordForm />
        <Divider />
        {this.renderDeleteAccountForm()}
        {this.renderTermsAndPrivacyLink()}
      </div>
    );
  },
});

export default UserSettingsView;



// WEBPACK FOOTER //
// ./src/settings/components/UserSettingsView.jsx